<template>
  <div class="body">
    <div class="title">
      <el-input class="searchInput"
                placeholder="姓名/手机号"
                :value="custPools.search"
                @input="input"
                @change="search"
      ></el-input>
      <div class="handle-part">
        <el-select class="searchSelect"
                   :value="custPools.grade"
                   @change="selector(1,$event)"
                   placeholder="客户等级">
          <el-option
            v-for="item in grade"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-cascader
          class="searchSelect"
          :options="departments"
          @change="departmentsEnd(2,$event)"
          :value="custPools.subbranch"
          :props="{ multiple: false, checkStrictly: true,
                      value:'code',label:'name',children:'sub'}"
          placeholder="分店显示"
          clearable>
        </el-cascader>
        <el-select class="searchSelect"
                   :value="custPools.degree"
                   @change="poolSelector(3,$event)"
                   placeholder="入池次数">
          <el-option
            v-for="(item,index) in shutters"
            :key="index"
            :label="item.label"
            :value="index"
          ></el-option>
        </el-select>
        <div class="btn-handle btn-inquire"
        @click="inquire"
        >
          查询
        </div>
        <div class="btn-handle btn-reset "
        @click="reset"
        >
          重置
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="pools"
        height="calc(100% - 4rem)"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="name"
          label="姓名"
          width="100">
        </el-table-column>
        <el-table-column
          prop="sex"
          width="80"
          label="性别"
          :formatter="sexType"
        ></el-table-column>
        <el-table-column prop="age" label="年龄" width="80"></el-table-column>
        <el-table-column prop="telNumber" width="120" label="电话"></el-table-column>
        <el-table-column prop="departmentName" label="部门"></el-table-column>
        <el-table-column prop="birthDt" label="出生日期"></el-table-column>
        <el-table-column prop="roleName" label="会员类型"></el-table-column>
        <el-table-column prop="entryDt" label="录入时间"></el-table-column>
        <el-table-column prop="releaseTime" label="释放次数" width="80"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operation">
              <i class="iconfont distance"
                 @click="customerDetails(scope.row.id)"
                 style="color:#5994FF">&#xe63a;</i>
              <i class="iconfont icon-shanchu distance"
                 @click="removeCilent(scope.row.id)"
                 style="color:red"></i>
              <i class="iconfont icon-tiquliuliang distance"
                 @click="extract(scope.row)"
                 style="color:#5994FF"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-headcount">
        <div class="customNumber">客户人数:
          <span style="color:#3495EF">{{ custPools.total }}</span>
          人
        </div>
        <el-pagination background layout="prev, pager, next"
                       :current-page="custPools.current"
                       :page-size="custPools.size"
                       :total="custPools.total"
                       @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 重置修改用户密码 -->
    <div class="shade" v-if="isExtract">
      <div class="Staff-after">
        <div class="Staff-after-title">提取客户</div>
        <el-autocomplete
          style="width:calc(100% - 4rem);margin:0.7rem 0"
          popper-class="my-autocomplete"
          v-model="staff"
          :fetch-suggestions="querySearch"
          placeholder="请输入姓名和电话"
          ref="elAutocomplete"
          @select="handleSelect"
          :trigger-on-focus="true"
        >
          <i
            class="el-icon-search"
            style="font-size: 20px;margin-top: 11px"
            slot="suffix"
            @click="showSearchColumn"
          >
          </i>
          <template slot-scope="{ item }">
            <div class="search-title" v-if="item.id === subOneId">
              <span>姓名</span>
              <span>电话</span>
              <span>所属部门</span>
            </div>
            <div class="search-list-content">
              <span>{{ item.name }}</span>
              <span>{{ item.telNumber }}</span>
              <span>{{ item.departmentName }}</span>
            </div>
          </template>
        </el-autocomplete>
        <div class="Staff-after-btn">
          <div class="Staff-after-btn-single"
               style="border:1px solid #DCDFE6"
               @click="cancelExtract"
          >
            取消
          </div>
          <div class="Staff-after-btn-single"
               style="background-color: #0e77ca;color:white"
               @click="confirmExtract"
          >
            确定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CUSTOMER_POOL_ANEW_REQUSET_DATA,
  CUSTOMER_POOL_INIT_DATA,
  CUSTOMER_POOL_INPUT_BOX,
  CUSTOMER_POOL_PAGINATION_INFO, CUSTOMER_POOL_PARAM_CAHNGES_INQUIRE, CUSTOMER_POOL_RESET_REQUEST_PARAM
} from "../../vuex/custPool/type";
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";


export default {
  name: "index",
  data() {
    return {
      //客户等级
      grade: [],
      //释放次数
      shutters: [],
      //所有部门
      departments: [],
      staff:'',
      subOneId:'',
      staffId: 0,
      staffCode:'',
      staffDepartment:'',
      isExtract:false,
      client:''
    }
  },
  computed: {
    pools() {
      return this.$store.getters["cust_pool/getPagCustPool"]
    },
    custPools() {
      return this.$store.getters["cust_pool/getAllPools"]
    }
  },
  created() {
    this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_INIT_DATA}`,true)
    this.GetFilterCriteria() //获取筛选条件
    // setTimeout(() => {
    //   console.log(this.pools)
    // }, 3000)
  },
  methods: {
    // 修改table header的背景色
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return 'background-color: #ECEEF0;color: #606266;'
      }
    },
    //性别判断
    sexType(row, column) {
      if (row.sex == 1) {
        return '男'
      } else {
        return '女'
      }
    },
    //页数发生改变时
    handleCurrentChange(val) {
      this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_PAGINATION_INFO}`, val)
    },
    //输入框事件
    input($event) {
      this.$store.commit(`cust_pool/${CUSTOMER_POOL_INPUT_BOX}`,
        {
          type: 0,
          value: $event
        })
    },
    //获取客户等级，入池次数，分店显示
    GetFilterCriteria() {
      axios.post(`${ipAddress.qi}/admin/a1/customer/getCustomerTypeAndTime`).then(value => {
        const success = value.success
        if (success) {
          const content = value.content
          this.grade = content.customerType
          this.shutters = content.releaseTime
        }
      })
      axios.post(`${ipAddress.qi}/admin/a1/department/listByStaff`).then(value => {
        const success = value.success
        if (success) {
          this.departments = value.content
        }
      })
    },
    //选择器发生改变时
    selector(type, event) {
      this.$store.commit(`cust_pool/${CUSTOMER_POOL_INPUT_BOX}`,
        {
          type: type,
          value: event
        })
    },
    //分店显示的变化
    departmentsEnd(type, event) {
      const length = event.length
      if (event && length > 0) {
        const value = event[length - 1]
        this.selector(type, value)
      }else {
        this.selector(type, '')
      }
    },
    //入池次数变化
    poolSelector(type, event) {
      const degreeStart = this.shutters[event].value
      const degreeEnd = this.shutters[event].key
      this.$store.commit(`cust_pool/${CUSTOMER_POOL_INPUT_BOX}`,
        {
          type: type,
          value: event,
          start: degreeStart,
          end: degreeEnd
        })
    },
    //点击编辑详情
    customerDetails(id) {
      this.$router.replace(`customers/basicinfo/${id}/${2}`)
    },
    //点击删除客户
    removeCilent(id) {
      let params = new URLSearchParams()
      params.set("id", id)
      axios.post(`${ipAddress.qi}/admin/a1/customer/delById`, params).then(
        value => {
          const success = value.success
          const msg = value.message
          if (success) {
            Message.success("删除成功！")
            //删除客户后重新拉去一下该页面数据
            this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_ANEW_REQUSET_DATA}`)
          } else {
            Message.warning(msg)
          }
        }
      )
    },
    //点击提取客户
    extract(client) {
      this.isExtract = true
      this.client = client
    },
    //返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它
    querySearch(text, callback) {
      if (text) {
        let params = {
          key: text,
          type: 0
        }
        axios.post(`${ipAddress.qi}/admin/a1/staff/queryLimited`, params, true).then(
          value => {
            let content = value.content
            if (!content || content.length < 1) {
              content = [{id: -1, name: "暂无匹配数据"}]
            } else {
              this.subOneId = content[0].id //记录第一个姓名的id用于判断
              this.searchs = content
            }
            // 调用 callback 返回建议列表的数据
            callback(content)
          }
        )
      }
    },
    //仅在输入框失去焦点或用户按下回车时触发
    handleSelect(event) {
      this.staff = event.name
      this.staffId = event.id
      this.staffCode = event.jobNumber
      this.staffDepartment = event.departmentCode
    },
    showSearchColumn() {
      this.$refs.elAutocomplete.handleFocus()
    },
    //点击取消提取
    cancelExtract(){
      this.isExtract = false
      this.client = ''
      this.staff = ''
      this.staffId = ''
      this.staffCode = ''
      this.subOneId = ''
      this.staffDepartment = ''
    },
    //点击确认提取客户
    confirmExtract(){
      const params = {
        id:this.client.id,
        staff_id:this.staffId,
        staff_code:this.staffCode,
        staff_department:this.staffDepartment
      }
      axios.post(`${ipAddress.qi}/admin/a1/customer/extractById`,params,true).then(
        value =>{
          const success = value.success
          if(success){
            Message.success("提取成功")
            this.cancelExtract()
            this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_ANEW_REQUSET_DATA}`)
          }else {
            const msg = value.message
            Message.error(msg)
          }
        }
      )
    },
    //点击查询按钮，参数发生改变
    inquire(){
       this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_PARAM_CAHNGES_INQUIRE}`)
    },
    //点击重置按钮，重新拉去数据
    reset(){
       this.$store.dispatch(`cust_pool/${CUSTOMER_POOL_RESET_REQUEST_PARAM}`)
    },
    //input发生改变出发搜索
    search(){
      this.inquire()
    }
  }
}
</script>

<style scoped>
@import "index.css";
</style>



// WEBPACK FOOTER //
// src/components/CustPool/index.vue